<template>
  <td>
    <input @blur="store()" type="text" class="form-control" v-model="input" />
  </td>
</template>

<script>
export default {
  props: ["content", "model", "attribute"],
  data() {
    return {
      input: this.content
    };
  },
  methods: {
    store() {
      return this.$http
        .patch(this.model[this.attribute.url], { input: this.input })
        .then(() => {
          this.$notify({
            title: this.attribute.message || "Das Wort wurde gespeichert",
            type: "success"
          });
        });
    }
  }
};
</script>
